var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":_vm.$vuetify.breakpoint.width < 1024 ? 'inspire-mobile' : ''}},[_c('div',{staticClass:"wrap"},[_c('router-view'),_c('FooterLayout',{attrs:{"isAuth":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }